<template>
  <q-page padding>
    <!-- loading overlay para upload de imagem -->
    <q-inner-loading :showing="uploadingImage" style="z-index: 9999">
      <div class="column items-center">
        <q-spinner-hourglass size="50px" color="primary" />
        <div class="text-brand-5 text-weight-bold q-mt-md">
          Fazendo upload da imagem, aguarde...
        </div>
      </div>
    </q-inner-loading>

    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Listagem de Produtos - Novo
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-2 q-mr-sm">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>
        <ListaUnidadesSelect v-model="unidade" />
      </div>
      <div class="col-md-2 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Nome do Produto</div>
        <q-input v-model="busca" dense outlined />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn-buscar"
          color="primary"
          label="Buscar"
          no-caps
          icon="filter_alt"
          @click="listarProdutos()"
        />
      </div>
    </div>
    <div class="q-mt-xl col-12 container-table">
      <div
        class="text-brand-5 text-subtitle1 text-weight-bold q-mb-lg texto-titulo-table"
      >
        Todos os Produtos Criados
      </div>
      <q-table
        :columns="columns"
        :rows="listaProdutos"
        color="primary"
        row-key="id"
        selection="single"
        class="tabela-tamanho-fixo"
        :grid="$q.screen.lt.sm"
        table-header-class="bg-accent text-weight-bold"
        dense
        hide-pagination
        hide-bottom
        v-model:pagination="pagination"
        :loading="loading"
        @request="paginarTabela"
        flat
        v-model:selected="selected"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5">
              <div class="col-4 q-pa-md">
                <div class="img-grid-container">
                  <q-img
                    class="img-grid-table"
                    v-if="props.row.product_images.length > 0"
                    :src="props.row.product_images[0]?.url"
                  >
                    <q-btn
                      v-if="props.selected"
                      class="absolute all-pointer-events cursor"
                      color="white"
                      style="bottom: -5px; right: -3px"
                      text-color="red"
                      flat
                      round
                      size="md"
                      icon="delete"
                      @click="removerImagem(props.row.product_images[0].id)"
                    />
                  </q-img>
                </div>
              </div>
              <div class="col-6 q-ml-sm q-mt-md">
                <div class="row col-12">
                  <span class="col-9 q-ml-sm q-mb-xs"
                    ><strong>Código: </strong>{{ props.row.code }}</span
                  >
                  <span class="col-9 q-ml-sm q-mb-xs"
                    ><strong>Nome: </strong
                    >{{
                      props.row.pivot?.contract_product_description ||
                      props.row.name ||
                      ""
                    }}</span
                  >
                  <span class="col-9 q-ml-sm q-mb-xs"
                    ><strong>Descrição: </strong
                    >{{
                      props.row.pivot?.contract_product_description ||
                      props.row.description ||
                      ""
                    }}</span
                  >
                  <span class="col-9 q-ml-sm q-mb-xs"
                    ><strong>Múltiplo: </strong>
                    <span v-if="!props.selected">{{
                      props.row.stock?.[0]?.pivot?.multiplo || ""
                    }}</span>
                    <input
                      v-else
                      v-model="multiplo"
                      maxlength="2"
                      type="text"
                      class="input-multiplo-grid"
                      placeholder="1 a 99"
                    />
                  </span>
                  <span class="col-9 q-ml-sm q-mb-xs"
                    ><strong>Data Criação: </strong>{{ formatarData(props.row.created_at) }}</span
                  >
                  <span class="col-9 q-ml-sm q-mb-xs"
                    ><strong>Data Última Atualização: </strong>{{ formatarData(props.row.updated_at) }}</span
                  >
                </div>
              </div>
              <div class="col-12">
                <div class="text-brand-5 btn-grid-container">
                  <div class="row">
                    <div class="column col-3">
                      <div v-if="!props.row.product_images.length > 0">
                        <label
                          class="btn info"
                          for="arquivo"
                          @click="recebeId(props.row.id)"
                        >
                          <q-btn
                            no-caps
                            stack
                            class="btn-grid-esquerdo"
                            label="Upload Imagem"
                            style="
                              background: #425a92;
                              color: white;
                              height: 100%;
                              width: 100%;
                              overflow: hidden;
                              z-index: -1;
                            "
                            icon="file_upload"
                          />
                        </label>
                        <input
                          id="arquivo"
                          type="file"
                          @change="onFileSelected"
                        />
                      </div>
                      <div v-else>
                        <q-btn
                          no-caps
                          stack
                          class="btn-grid-esquerdo"
                          disable
                          label="Upload Imagem"
                          style="
                            background: #425a92;
                            color: white;
                            height: 100%;
                            width: 100%;
                            overflow: hidden;
                            z-index: -1;
                          "
                          icon="file_upload"
                        />
                      </div>
                    </div>
                    <div class="col-3">
                      <q-btn
                        icon="qr_code"
                        no-caps
                        stack
                        label="Qr Code"
                        style="
                          width: 100%;
                          background: #8bcfde;
                          color: white;
                          height: 100%;
                        "
                        class="btn-grid-meio"
                        @click="recebeDadosQrCode(props.row, (qrMobile = true))"
                      />
                    </div>

                    <div class="column col-6">
                      <q-btn
                        v-if="!props.selected"
                        no-caps
                        stack
                        label="Editar"
                        class="btn-grid-direito"
                        style="background: #393939; color: white; height: 100%"
                        icon="edit"
                        @click="props.selected = !props.selected"
                      />
                      <q-btn
                        v-else
                        no-caps
                        stack
                        color="positive"
                        class="btn-grid-direito"
                        label="Salvar Alterações"
                        icon="check_circle_outline"
                        @click="
                          alterarMultiplo(
                            props.row.id,
                            props.row.stock?.[0]?.pivot?.multiplo
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span>{{ props.row.id }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.code }}</span>
            </q-td>
            <q-td>
              <div class="img-container">
                <q-img
                  v-if="props.row.product_images.length > 0"
                  class="img"
                  :src="props.row.product_images[0]?.url"
                >
                  <q-btn
                    v-if="props.selected"
                    class="absolute all-pointer-events cursor"
                    color="white"
                    style="bottom: -5px; right: -3px"
                    text-color="red"
                    flat
                    round
                    size="sm"
                    icon="delete"
                    @click="removerImagem(props.row.product_images[0].id)"
                  />
                </q-img>
                <q-img v-else class="img">
                  <q-file
                    borderless
                    v-model="file"
                    class="absolute all-pointer-events cursor"
                    color="white"
                    style="bottom: 0px; right: -0px; font-size: 0px"
                    @click="recebeId(props.row.id)"
                  >
                    <q-icon
                      name="file_upload"
                      size="lg"
                      class="absolute all-pointer-events cursor"
                      style="
                        bottom: 3px;
                        right: 7px;
                        color: #b4b4b4;
                        cursor: pointer;
                      "
                    />
                  </q-file>
                </q-img>
              </div>
            </q-td>
            <q-td>
              <span>{{
                props.row.pivot?.contract_product_description ||
                props.row.description ||
                ""
              }}</span>
            </q-td>
            <q-td>
              <span v-if="!props.selected">{{
                props.row.stock?.[0]?.pivot?.multiplo || ""
              }}</span>
              <div v-else>
                <div class="col" style="width: 100px">
                  <q-input v-model="multiplo" mask="##" dense outlined />
                </div>
              </div>
            </q-td>
            <q-td>
              <span>{{ formatarData(props.row.created_at) }}</span>
            </q-td>
            <q-td>
              <span>{{ formatarData(props.row.updated_at) }}</span>
            </q-td>
            <q-td>
              <q-btn
                icon="qr_code"
                flat
                square
                dense
                style="
                  color: #fff;
                  background: #8bcfde;
                  border-radius: 6px;
                  padding: 5px;
                  margin-left: 6px;
                "
                @click="recebeDadosQrCode(props.row)"
              />
            </q-td>
            <q-td>
              <q-btn
                icon="qr_code"
                flat
                square
                dense
                style="
                  color: #fff;
                  background: #8bcfde;
                  border-radius: 6px;
                  padding: 5px;
                  margin-left: 6px;
                "
                @click="recebeDadosQrCodeNovo(props.row)"
              />
            </q-td>
            <q-td class="text-center">
              <q-btn
                v-if="!props.selected"
                icon="edit"
                flat
                dense
                round
                @click="props.selected = !props.selected"
              />
              <q-btn
                v-else
                dense
                label="Salvar Alterações"
                icon="check_circle_outline"
                class="btn"
                no-caps
                outline
                color="positive"
                @click="
                  alterarMultiplo(
                    props.row.id,
                    props.row.stock?.[0]?.pivot?.multiplo
                  )
                "
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <span class="q-ml-sm text-brand-5 text-weight-bold"
            >Deseja mesmo fazer o upload ?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Não"
            no-caps
            color="negative"
            v-close-popup
            icon="cancel"
            dense
          />
          <q-btn
            label="Sim"
            color="positive"
            no-caps
            icon="check_circle_outline"
            dense
            v-close-popup
            @click="uploadImagem()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="qrcodeModal" :persistent="true">
      <q-card style="border-radius: 20px; width: 765px">
        <q-card-section class="row items-center q-pb-none">
          <q-space />
          <q-btn
            color="brand-5"
            icon="close"
            size="12px"
            flat
            round
            dense
            @click="qrMobile = false"
            v-close-popup
          />
        </q-card-section>
        <div class="row col-12 text-brand-5 text-weight-bold q-pl-lg">
          <span class="text-body1 text-weight-bold">Etiqueta do Produto</span>
        </div>
        <div class="row col-12 q-pa-lg">
          <div class="col-5">
            <QrCode
              :value="codigoQrCode"
              :size="qrMobile == true ? 100 : 190"
            />
          </div>
          <div class="col text-weight-bolder">
            <div
              style="
                border: 3px solid #707070;
                height: 100px;
                border-radius: 10px;
              "
              class="row col-12 q-pa-sm"
            >
              <span class="qrcode-text"
                >{{
                  dadosQrCode.multiplo > 0 ? `${dadosQrCode.multiplo}X` : ""
                }}
                {{ dadosQrCode.nome.toUpperCase() }}
              </span>
            </div>
            <div class="row col-12 q-mt-xs">
              <div
                style="
                  border: 3px solid #707070;
                  height: 85px;
                  border-radius: 10px;
                "
                class="row col justify-center items-center q-pa-sm"
              >
                <span class="qrcode-text">{{ dadosQrCode.unidadeMedida }}</span>
              </div>
              <div
                style="
                  border: 3px solid #707070;
                  height: 85px;
                  border-radius: 10px;
                "
                class="row col items-center q-ml-xs q-pa-sm"
              >
                <span class="qrcode-text">{{
                  "CODIGO: " + dadosQrCode.codigo.toUpperCase()
                }}</span>
              </div>
            </div>
          </div>
          <div class="row col-12 justify-end q-mt-lg">
            <div>
              <q-btn
                label="Imprimir"
                color="black"
                no-caps
                icon="print"
                dense
                @click="imprimir()"
              />
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="qrcodeModalNovo" :persistent="true">
      <q-card style="border-radius: 20px; width: 527px">
        <q-card-section class="row items-center q-pb-none">
          <q-space />
          <q-btn
            color="brand-5"
            icon="close"
            size="12px"
            flat
            round
            dense
            @click="qrMobile = false"
            v-close-popup
          />
        </q-card-section>
        <div
          style="
            border: solid 2px black;
            margin: 0px 24px;
            border-radius: 8px;
            width: 439px;
          "
          class="column col-8 text-brand-5 text-weight-bold q-pl-lg"
        >
          <span style="font-size: 10px" class="text-weight-bold"
            >Descrição</span
          >
          <span class="text-brand-1 text-weight-bold"
            >{{ dadosQrCode.multiplo > 0 ? `${dadosQrCode.multiplo}X` : "" }}
            {{ dadosQrCode.nome }}</span
          >
        </div>
        <div style="padding: 10px 24px 10px 24px" class="row col-12">
          <div>
            <QrCode
              :value="codigoQrCode"
              :size="qrMobile == true ? 100 : 210"
            />
          </div>
          <div
            style="border: 2px solid black; width: 210px; border-radius: 10px"
            class="q-ml-md col-5"
          >
            <q-img class="img-grid-table" :src="dadosQrCode.image"> </q-img>
          </div>
        </div>
        <div style="padding-left: 24px" class="row col-12 text-weight-bolder">
          <div
            style="
              border: 2px solid black;
              height: 50px;
              border-radius: 10px;
              padding: 5px 0px 5px 10px;
            "
            class="column col-5 q-ml-xs q-pa-sm"
          >
            <span style="font-size: 10px" class="text-weight-bold">Código</span>
            <span class="qrcode-text text-brand-1">{{
              dadosQrCode.codigo.toUpperCase()
            }}</span>
          </div>
          <div
            style="
              border: 2px solid black;
              height: 50px;
              border-radius: 10px;
              padding: 5px 0px 5px 10px;
            "
            class="column q-ml-md col-5"
          >
            <span style="font-size: 10px" class="text-weight-bold"
              >Unidade De medida</span
            >
            <span class="qrcode-text text-brand-1">{{
              dadosQrCode.unidadeMedida
            }}</span>
          </div>
          <div class="row col-11 justify-end q-mt-sm q-pa-sm">
            <div>
              <q-btn
                label="Imprimir"
                color="black"
                no-caps
                icon="print"
                dense
                @click="imprimirNovo()"
              />
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

import QrCode from "../components/QrCode.vue";

export default {
  components: { QrCode, ListaUnidadesSelect },
  setup() {
    const columns = [
      {
        name: "id",
        label: "ID",
        align: "left",
        field: "id",
      },
      {
        name: "codigo",
        label: "Código",
        align: "left",
        field: "code",
      },
      {
        name: "imagem",
        label: "Imagem",
        align: "left",
      },
      {
        name: "descricao",
        label: "Descrição",
        align: "left",
        field: "description",
      },
      {
        name: "multiplo",
        label: "Múltiplo",
        align: "left",
      },
      {
        name: "created_at",
        label: "Data Criação",
        align: "left",
        field: "created_at",
      },
      {
        name: "updated_at",
        label: "Data Última Atualização",
        align: "left",
        field: "updated_at",
      },
      {
        name: "etiqueta",
        label: "Etiqueta",
        align: "left",
      },
      {
        name: "etiquetaNovo",
        label: "Etiqueta Novo",
        align: "left",
      },
      {
        name: "editar",
        label: "Editar",
        align: "center",
      },
    ];
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();
    const qrMobile = ref(false);
    const listaProdutos = ref();
    const selected = ref([]);
    const time = ref(null);

    const listaUnidades = ref([]);
    const unidade = ref();
    const file = ref(null);
    const img = ref();
    let loading = ref(false);
    let id = ref("");
    let confirm = ref(false);
    let busca = ref();
    const codigoQrCode = ref("");
    let qrcodeModal = ref(false);
    let qrcodeModalNovo = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let disable = ref(false);
    const dadosQrCode = ref({
      unidadeMedida: "",
      codigo: "",
      nome: "",
      codigoInalterado: "",
      multiplo: "",
    });
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const multiplo = ref("");
    const uploadingImage = ref(false);

    const formatarData = (dataString) => {
      if (!dataString) return "";
      const data = new Date(dataString);
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const ano = data.getFullYear();
      const horas = String(data.getHours()).padStart(2, "0");
      const minutos = String(data.getMinutes()).padStart(2, "0");
      return `${dia}-${mes}-${ano} ${horas}:${minutos}`;
    };

    const listarProdutos = async (page = 1, rowsPerPage = 6) => {
      if (store.state.org.contract == undefined) {
        return;
      }
      disable.value = true;
      loading.value = true;
      try {
        store.dispatch("pdt/hiddenHeader", true);
        let response = await store.dispatch("produtosNovo/listarProdutos", {
          per_page: rowsPerPage,
          page: page,
          search: busca.value,
          contract_id: store.state.org.contract,
        });
        listaProdutos.value = response.data.model.products.data;
        pagination.value.rowsPerPage = response.data.model.products.per_page;
        pagination.value.page = response.data.model.products.current_page;
        pagination.value.rowsNumber = response.data.model.products.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarUnidades = async (val) => {
      try {
        let response = await store.dispatch("produtos/getUnidades", {
          search: val,
        });

        listaUnidades.value = response.data.results.data;
      } catch (error) {
        console.log(error);
      }
    };

    const removerImagem = async (id) => {
      try {
        await store.dispatch("produtosNovo/deletarImagem", {
          productId: id,
        });
        listarProdutos();
        selected.value = [];
        quasar.notify({
          message: "Imagem removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const recebeId = async (value) => {
      id.value = value;
    };

    watch(
      () => file.value,
      () => {
        let fileReader = new FileReader();

        fileReader.readAsDataURL(file.value);
        fileReader.addEventListener("load", () => {
          img.value = fileReader.result;
        });

        confirm.value = true;
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => busca.value,
      () => {
        if (busca.value.length == 0) {
          listarProdutos();
        }
      }
    );

    const uploadImagem = async () => {
      try {
        uploadingImage.value = true;
        await store.dispatch("produtosNovo/uploadImagem", {
          product_id: id.value,
          image: img.value,
          contract_id: store.state.org.contract,
        });
        selected.value = [];
        // reseta file para permitir novo upload
        file.value = null;
        listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
        quasar.notify({
          message: "Upload de imagem feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao fazer upload de imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } finally {
        uploadingImage.value = false;
      }
    };

    const alterarMultiplo = async (id) => {
      if (multiplo.value == "") {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("produtosNovo/alterarMultiplo", {
          vendorId: recebeUnidade.value.id,
          productId: id,
          multiplo: multiplo.value,
        });
        listarProdutos();
        multiplo.value = "";
        selected.value = [];
        quasar.notify({
          message: "Múltiplo alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao alterar múltiplo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const paginarTabela = async () => {
      listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const recebeDadosQrCode = async (dados) => {
      // Verificar se a estrutura existe antes de acessar
      const stock = dados.stock?.[0];
      const pivot = stock?.pivot;
      const contractDescription = dados.pivot?.contract_product_description;

      dadosQrCode.value.multiplo = pivot?.multiplo || 1;
      dadosQrCode.value.nome = contractDescription || dados.name || "";
      dadosQrCode.value.codigoInalterado = dados.code || "";
      dadosQrCode.value.codigo = dados.code || "";
      dadosQrCode.value.unidadeMedida = pivot?.measurement_unit || "UN";
      codigoQrCode.value = `${dadosQrCode.value.codigo}%${dadosQrCode.value.multiplo}`;
      qrcodeModal.value = true;
    };

    const recebeDadosQrCodeNovo = async (dados) => {
      // Verificar se a estrutura existe antes de acessar
      const stock = dados.stock?.[0];
      const pivot = stock?.pivot;
      const contractDescription = dados.pivot?.contract_product_description;

      dadosQrCode.value.multiplo = pivot?.multiplo || 1;
      dadosQrCode.value.nome = contractDescription || dados.name || "";
      dadosQrCode.value.codigoInalterado = dados.code || "";
      dadosQrCode.value.codigo = dados.code || "";
      dadosQrCode.value.unidadeMedida = pivot?.measurement_unit || "UN";
      dadosQrCode.value.image = dados?.product_images?.[0]?.url || "";
      codigoQrCode.value = `${dadosQrCode.value.codigo}%${dadosQrCode.value.multiplo}`;
      qrcodeModalNovo.value = true;
    };

    const imprimir = () => {
      router.push({
        name: "imprimir-etiqueta-novo",
        params: {
          produtoId: dadosQrCode.value.codigo,
          contractId: store.state.org.contract,
        },
      });
    };

    const imprimirNovo = () => {
      router.push({
        name: "imprimir-etiqueta-opcional",
        params: {
          produtoId: dadosQrCode.value.codigo,
          contractId: store.state.org.contract,
        },
      });
    };

    let onFileSelected = async (e) => {
      if (!e.target.files || e.target.files.length === 0) {
        return;
      }
      file.value = e.target.files[0];
      e.target.value = '';
    };

    watch(
      () => store.state.org.contract,
      () => {
        listarProdutos();
      }
    );

    onMounted(() => {
      listarProdutos();
    });

    return {
      columns,
      listarProdutos,
      listaProdutos,
      selected,
      loading,
      removerImagem,
      file,
      uploadImagem,
      id,
      recebeId,
      confirm,
      busca,
      pagination,
      unidade,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      paginarTabela,
      disable,
      codigoQrCode,
      qrcodeModal,
      qrcodeModalNovo,
      recebeDadosQrCode,
      recebeDadosQrCodeNovo,
      dadosQrCode,
      alterarMultiplo,
      recebeUnidade,
      multiplo,
      imprimir,
      onFileSelected,
      qrMobile,
      listaUnidades,
      imprimirNovo,
      formatarData,
      uploadingImage,
      filterUnidade(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarUnidades(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.img-container {
  width: 60px;
  height: 60px;
  padding: 3px;
  border: 1px solid #00000029;
  border-radius: 5px;
  font-weight: bold;
}
.img {
  width: 100%;
  height: 100%;
}
.qrcode-text {
  font-size: 14px;
  word-wrap: break-word;
  width: 100%;
}
input[type="file"] {
  display: none;
}
.btn[data-v-0e47b9a4] {
  font-size: 12px;
  margin: 0px 0px 0px 0px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .container-inputs {
    margin: 8px 0px 0px 0px;
    padding: 0px;
  }
  .btn-buscar {
    font-size: 12px;
    margin: 6px 0px 0px 0px;
    height: 30px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .container-table {
    margin-left: 4px;
    margin-right: 4px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .texto-titulo-table {
    display: none;
  }
  .img-grid-container {
    height: 90px;
    width: 100px;
    border: 1px solid #b4b4b4;
    border-radius: 5px;
  }
  .img-grid-table {
    height: 100%;
    width: 100%;
    border-radius: 5px;
  }
  .btn-grid-esquerdo {
    border-radius: 0px 0px 0px 5px;
    font-size: 12px;
  }

  .btn-grid-meio {
    border-radius: 0px 0px 0px 0px;
    font-size: 12px;
  }
  .btn-grid-direito {
    border-radius: 0px 0px 5px 0px;
    font-size: 12px;
  }
  .input-multiplo-grid {
    width: 70px;
    outline: none;
  }
}
</style>
